import SdsSubject from "../../../../models/SdsSubject";

import { Dictionary } from "lodash";
import * as _ from "lodash";
import {SubjectMerge} from "../../../../models/SubjectMerge";

export class SubjectItem {
    public static clone(originalItem: SubjectItem): SubjectItem {
        const clonedItem = new SubjectItem();
        clonedItem.name = originalItem.name;
        clonedItem.code = originalItem.code;
        clonedItem.isExistingMerge = originalItem.isExistingMerge;
        clonedItem.isRenamed = originalItem.isRenamed;


        clonedItem.mergedSubjects.push(...originalItem.mergedSubjects);

        return clonedItem;
    }
    
    public static merge(originalItem: SubjectItem, itemToMergeIn: SubjectItem): SubjectItem {
        const mergedItem = SubjectItem.clone(originalItem);

        mergedItem.mergedSubjects.push({ subjectCode: itemToMergeIn.code, subjectName: itemToMergeIn.name });

        itemToMergeIn.mergedSubjects.forEach((subjectMerge) => {
            mergedItem.mergedSubjects.push(subjectMerge);
        });

        return mergedItem;
    }

    public static split(subjectItem: SubjectItem, subjectCodeToUnmerge: string, sdsSubjectDict: Dictionary<SdsSubject>): { updatedItem: SubjectItem, newItem: SubjectItem } {
        const updatedItem = SubjectItem.clone(subjectItem);

        const subjectsToRemove = updatedItem.mergedSubjects.filter(ms => ms.subjectCode === subjectCodeToUnmerge);
        subjectsToRemove.forEach(subjectToRemove => {
            const index = updatedItem.mergedSubjects.indexOf(subjectToRemove);
            updatedItem.mergedSubjects.splice(index, 1);
        });

        const sdsSubject = sdsSubjectDict[subjectCodeToUnmerge];
        const newItem = sdsSubject ? SubjectItem.fromSdsSubject(sdsSubject) : SubjectItem.fromSubjectCode(subjectCodeToUnmerge);

        return { updatedItem, newItem };
    }

    public static fromSubjectMerge(subjectMerge: SubjectMerge, sdsSubjectDict: Dictionary<SdsSubject>) {
        const item = new SubjectItem();

        item.name = subjectMerge.targetSubjectName;
        item.code = subjectMerge.targetSubjectCode;
        
        if(subjectMerge.isNew)
        {
            item.isExistingMerge = false;
        }
        else
        {
            item.isExistingMerge = true;
        }

        let mergedSubjects = subjectMerge.sourceSubjectCodes
            .filter((subjectCode) => subjectCode !== subjectMerge.targetSubjectCode)
            .map((subjectCode) => {
                const sdsSubject = sdsSubjectDict[subjectCode];
                return sdsSubject ? sdsSubject : { subjectCode: subjectCode };
            });

        mergedSubjects = _.sortBy(mergedSubjects, ["subjectName", "subjectCode"]);
        item.mergedSubjects.push(...mergedSubjects);

        return item;
    }

    public static fromSdsSubject(sdsSubject: SdsSubject) {
        const item = new SubjectItem();

        item.name = sdsSubject.subjectName
        item.code = sdsSubject.subjectCode;

        item.isExistingMerge = false;
        return item;
    }

    public static fromSubjectCode(subjectCode: string) {
        const item = new SubjectItem();

        item.name = subjectCode;
        item.code = subjectCode;

        item.isExistingMerge = false;
        return item;
    }

    public name: string;
    public code: string;

    private isExistingMerge: boolean;
    private isRenamed: boolean;

    public readonly mergedSubjects: { subjectCode: string, subjectName?: string }[];

    private constructor() {
        this.name = "";
        this.code = "";
        this.isExistingMerge = false;
        this.isRenamed = false;
        this.mergedSubjects = [];
    }

    public containsMerges(): boolean {
        return this.isExistingMerge || this.mergedSubjects.length > 0;
    }

    public toSubjectMerge(): SubjectMerge {
        return {
            targetSubjectCode: this.code,
            targetSubjectName: this.name,
            sourceSubjectCodes: _.uniq([this.code, ...this.mergedSubjects.map(ms => ms.subjectCode)]),
            isNew: !this.isExistingMerge
        };
    }

    public rename(newName: string) {
        this.name = newName;
        this.isRenamed = true;
    }

    public containsUnSavedRename() {
        return this.isRenamed;
    }

    public static AlphabeticalCompare(a: SubjectItem, b: SubjectItem): number {
        if (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase()) { return -1; }
        if (a.name.toLocaleLowerCase() > b.name.toLocaleLowerCase()) { return 1; }
        return 0;
    }
}